import React, { Fragment } from "react";
import Loader from "../../common/Loader"
import { CLASSNAME_P_B, CLASSNAME_P_T, CLASSNAME_P_L, CLASSNAME_P_R, CLASSNAME_M_B, CLASSNAME_M_T, CLASSNAME_M_L, CLASSNAME_M_R } from '../../constant/bannerItems'
import { Checkbox, FormControlLabel, List, ListItem, ListItemText, Button, FormControl, Select, MenuItem ,styled, TextField} from "@mui/material"


const StyledFormControl = styled(FormControl)({
    width: '40ch',
});



const ActionGridSpaceForm = ({ handleCheckboxInputChange, actionGridId, isLoading, handleClose, inputs, handleInputChange, handleSubmit, errors, fromEditAction }) => {


	const errorClass = {
		color: "red",
	}

	const onSubmit = () => {
		handleSubmit()
	}

	return (
		<Fragment>
			{isLoading && (
				<Loader />
			)}
			<div className="banner-form" style={{ 'minHeight': '50vh' }}>
				<form className="banner-form-style" >
					<List>


						{fromEditAction === 'topBottomSpace' && (
							<>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Padding Top"
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingTop}
												onChange={handleInputChange}
												name="paddingTop">
												{CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
									}
									/>
									<ListItemText id="switch-list-label-wifi" primary="Padding Top" />
								</ListItem>
								<ListItem className="mb-35" 
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingBottom}
												onChange={handleInputChange}
												name="paddingBottom">
												{CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
										
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Padding Bottom" />
								</ListItem>
								<ListItem className="mb-35"  
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingLeft}
												onChange={handleInputChange}
												name="paddingLeft">
												{CLASSNAME_P_L && CLASSNAME_P_L.length && Object.keys(CLASSNAME_P_L).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_L[data].value}> {CLASSNAME_P_L[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
										
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Padding Left" />
									
								</ListItem>
								<ListItem className="mb-35"  
								   secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingRight}
												onChange={handleInputChange}
												name="paddingRight">
												{CLASSNAME_P_R && CLASSNAME_P_R.length && Object.keys(CLASSNAME_P_R).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_R[data].value}> {CLASSNAME_P_R[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
								   }
								>
									<ListItemText id="switch-list-label-wifi" primary="Padding Right" />
								</ListItem>
								<ListItem className="mb-35"
									secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginTop}
												onChange={handleInputChange}
												name="marginTop">
												{CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Top" />
								</ListItem>
								<ListItem className="mb-35"
								   secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginBottom}
												onChange={handleInputChange}
												name="marginBottom">
												{CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
								   }
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Bottom" />
								</ListItem>
								<ListItem className="mb-35"
								  secondaryAction={
									    <StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginLeft}
												onChange={handleInputChange}
												name="marginLeft">
												{CLASSNAME_M_L && CLASSNAME_M_L.length && Object.keys(CLASSNAME_M_L).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_L[data].value}> {CLASSNAME_M_L[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
								  }
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Left" />
								</ListItem>
								<ListItem className="mb-35"
								   secondaryAction={
										<StyledFormControl variant="outlined" >
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginRight}
												onChange={handleInputChange}
												name="marginRight">
												{CLASSNAME_M_R && CLASSNAME_M_R.length && Object.keys(CLASSNAME_M_R).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_R[data].value}> {CLASSNAME_M_R[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</StyledFormControl>
								   }
								>
									<ListItemText id="switch-list-label-wifi" primary="Margin Right" />
								</ListItem>

								<ListItem className="mb-35"
								    secondaryAction={
										<FormControlLabel
											sx={{
												width: '40ch',
											}}
											control={<Checkbox checked={inputs.fullSection} onChange={handleCheckboxInputChange} name="fullSection" className="ml-2 mt-1" />}
										/>
									}
								>
									<ListItemText id="switch-list-label-wifi" primary="Full Section" />
								</ListItem>

							</>
						)}


						<ListItem>
							<button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
							<Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {actionGridId ? "Update" : "Save"}</Button>

						</ListItem>
					</List>

				</form>
			</div>
		</Fragment>
	);
};

export default ActionGridSpaceForm;
